import {
  ApiClient,
  ApiClientContext,
  ApiClientOptions,
  RouteOptions,
  defaultAxiosConfig,
} from '@qualifio/api-client';
import { AxiosInstance } from 'axios';
import { DashboardReference } from './types/dashboard';

export class ReportApiClient extends ApiClient {
  static serviceName = 'report-api';

  constructor(http?: AxiosInstance, context?: ApiClientContext, options?: ApiClientOptions) {
    super('/api/report', http, context, options);
  }

  async getDashboardReference(
    programId: string,
    options?: RouteOptions,
  ): Promise<DashboardReference> {
    const { data } = await this.http.get(
      `/programs/${programId}/dashboard`,
      defaultAxiosConfig(options),
    );
    return data;
  }

  async recompute(date: Date, options?: RouteOptions): Promise<void> {
    await this.http.post(`/recompute`, { date }, defaultAxiosConfig(options));
  }

  async resetProgram(programId: string, date: Date, options?: RouteOptions): Promise<boolean> {
    const result = await this.http.post(
      `/programs/${programId}/reset`,
      { date: date.toISOString() },
      defaultAxiosConfig(options),
    );
    return result.status === 204;
  }
}
